import React, { useCallback, useMemo } from "react";
import type {
  OrderCodePartOptionStrict,
  OrderCodePartStrict,
} from "stores/product";
import { RadioInput as RadioInputComponent } from "components/Inputs/FormikInputs/RadioInput";
import { InputTitle } from "./InputTitle";
import type { OnChange } from "../OrderCodePartOption";
import { useIsLoadingEffect } from "./hooks/useIsLoadingEffect";

export const RadioInput = ({
  option,
  disabled,
  onChange,
  part,
  isModal = false,
}: {
  option: OrderCodePartOptionStrict;
  disabled: boolean;
  onChange: OnChange;
  part: OrderCodePartStrict;
  isModal?: boolean;
}) => {
  const [isLoading, setIsLoading] = useIsLoadingEffect();
  const optionsMemo = useMemo(
    () =>
      option.signatures?.filter((opt) => opt?.state < 2 || opt?.state === 4) ||
      [],
    [option],
  );

  const groupName = isModal
    ? `${part.key}-${option.key}___modal`
    : `${part.key}-${option.key}`;

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
      setIsLoading(true);
    },
    [onChange, setIsLoading],
  );

  return (
    <>
      <InputTitle title={option?.title} isloading={isLoading} />
      <div className="d-flex flex-row gap-3">
        {optionsMemo.map((opt) => (
          <RadioInputComponent
            key={opt?.key}
            label={`${opt?.title}${
              opt?.presentation ? ` (${opt?.presentation})` : ""
            }`}
            name={groupName}
            type="radio"
            value={opt?.key}
            checked={option.currentSignature?.key === opt?.key}
            disabled={disabled || opt?.state !== 0}
            data-testid={`${part.key}-${opt?.key}-${opt?.value}`}
            onChange={handleOnChange}
            // to fix type error, as RadioInputComponent expects these props but they are not relevant in this context
            field={undefined}
            classNames={undefined}
            htmlFor={undefined}
          />
        ))}
      </div>
    </>
  );
};
